export const INFORMATION_ROUTE = {
  path: 'information',
  name: 'Name',
};
